module.exports = __webpack_public_path__ + "0f771a94d60fa22ca19d634eca158853.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/NoAccess/assets/front-cover.jpg
 ** module id = 1556
 ** module chunks = 0
 **/